import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRecycle, faTrash} from "@fortawesome/free-solid-svg-icons";
import { Table } from "reactstrap";
import ReactTooltip from 'react-tooltip';
import './index.scss';
import { processes } from "../../../utils/constants";
import { dateFormat } from "../../../utils/common";
import moment from "moment";

const DocumentItem = ({ className = '', records,_deleteQueue,_viewDocuments,tryAgain,_reQueueDocument,_removeQueueDocument, _filterSelected }) => {

	return (
		<>

			<Table responsive>

				<thead>
					<tr>
						<th className='sort-heading'>
							<div className="sort-elem-cell d-inline-flex align-items-center">
								Name
							</div>
						</th>
						<th>Status</th>
						<th>Message</th>
						{ _filterSelected != "deleted" ? <th>Action</th> : null}
						<th>Try again attempt</th>
					</tr>
				</thead>
				<tbody>
					{
						records?.map((item, index) => {
							console.log('itemmm',item)
							return item?.upload_attempts && item?.upload_attempts.length ? item.upload_attempts.sort((b,a) => a?.createdAt?.localeCompare(b?.createdAt)).map((attempt, attemptIndex) => (
								<tr key={attemptIndex}>
									<td style={{maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} data-tip={item?.name} >{item?.name} </td>
									<td className='action-cell'>
										<label className={`text-danger`}>
											{'Error'} 
										</label>
									</td>
									<td>{item?.ml_response_error_message} </td>
									{ _filterSelected != 'deleted' ? <td>
										<FontAwesomeIcon style={{ cursor: "pointer", marginRight : "10px" }} icon={faRecycle} data-tip={'Requeue'} onClick={() => {_reQueueDocument(item?.queue,item?._id)}} />
										<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faTrash} data-tip={'Remove'} onClick={() => {_removeQueueDocument(item?.queue,item?._id) }} />
										<ReactTooltip className='global-tooltip'/>
									</td> : null}
									<td>{moment(attempt.createdAt).format("MMMM Do YYYY, hh:mm A")}</td>
								</tr>
							)) :
							<tr key={index}>
									<td>{item?.name} </td>
									<td className='action-cell'>
										<label className={`text-danger`}>
											{'Error'} 
										</label>
									</td>
									<td>{item?.ml_response_error_message} </td>
									{ _filterSelected != "deleted" ? <td>
										<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faRecycle} data-tip={'Requeue'} onClick={() => {_reQueueDocument(item?.queue,item?._id)}} />
										<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faTrash} data-tip={'Remove'} onClick={() => {_removeQueueDocument(item?.queue,item?._id) }} />
										<ReactTooltip />
									</td> : null}
									{/* <td>{moment(item?.createdAt).format("MMMM Do YYYY, hh:mm A")}</td> */}
								</tr>
						})
					}
				</tbody>
			</Table>
		</>


	);
};

export default DocumentItem;
